import { tv } from "../../variants/tv.js";
const counterIconButtonVariants = {
    primary: {
        add: 'primary',
        remove: 'secondary'
    },
    secondary: {
        add: 'secondary',
        remove: 'secondary'
    }
};
const counterIconButtonTypes = Object.keys(counterIconButtonVariants);
const counterSizeVariants = {
    sm: {
        root: 'w-24',
        ctaButton: 'w-24'
    },
    md: {
        root: 'w-32',
        ctaButton: 'w-32'
    },
    lg: {
        root: 'w-40',
        ctaButton: 'w-40'
    }
};
const counterSizes = Object.keys(counterSizeVariants);
const counterEmphasisVariants = {
    regular: {
        root: 'text-primary-13 disabled:text-primary-6'
    },
    medium: {
        root: 'text-primary-13 disabled:text-primary-6'
    },
    bold: {
        root: 'text-primary-1 disabled:text-primary-1/40'
    }
};
const counterEmphases = Object.keys(counterEmphasisVariants);
const counterVariants = tv({
    slots: {
        root: 'flex items-center justify-center gap-1',
        numericText: 'block min-w-0 flex-1 tabular-nums',
        ctaButton: ''
    },
    variants: {
        emphasis: counterEmphasisVariants,
        size: counterSizeVariants
    },
    compoundVariants: [],
    defaultVariants: {
        emphasis: 'regular',
        size: 'sm'
    }
});
export { counterEmphases, counterEmphasisVariants, counterIconButtonTypes, counterIconButtonVariants, counterSizeVariants, counterSizes, counterVariants };
